import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import TextField from '~fields/TextField';
import SelectField from '~fields/SelectField';

const PayerSection = () => {
  const [showPayer, setShowPayer] = useState(false);
  const organizations = useSelector(state => state.reducer.organizations);
  const organizationOptions = organizations?.map(org => ({
    value: org.id,
    label: org.name,
  }));

  return (
    <Wrapper>
      <div>
        <TogglePayer onClick={() => setShowPayer(!showPayer)}>
          {showPayer ? (
            <FontAwesomeIcon icon={faChevronUp} />
          ) : (
            <FontAwesomeIcon icon={faChevronDown} />
          )}
        </TogglePayer>
      </div>
      <div>
        <PayerWrapper onClick={() => setShowPayer(!showPayer)}>
          Maksajatiedot. Tarkistahan tiedot, jos niihin on tullut muutoksia
        </PayerWrapper>

        <Payer show={showPayer} className="cf">
          {organizationOptions && (
            <SelectField
              required
              placeholder="Valitse"
              name="payerOrganization"
              options={organizationOptions}
              defaultOptionLabel="Ei mitään"
              defaultOptionValue=""
            />
          )}
          <TextField name="function" placeholder="Kirjoita toimintakoodi" />
          <TextField name="project" placeholder="Kirjoita hankekoodi" />
        </Payer>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  font-size: 16px;
`;

const TogglePayer = styled.div`
  color: var(--primaryColor);
  cursor: pointer;
  display: table;
  font-size: 20px;
  margin-left: 2px;
  margin-right: 13px;
`;

const PayerWrapper = styled.div`
  color: var(--primaryColor);
  cursor: pointer;
`;

const Payer = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
  margin-top: 24px;

  & > * {
    margin-bottom: 24px;
  }
`;

export default PayerSection;
